import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Form, FormGroup, Label } from "reactstrap";
import {
  createSaveMoloniProduct,
  getListSupplierList,
  getProductCategoryList,
  getProductPropertyList,
  getTaxList,
  getUnitList,
  getViewMainproduct,
  getWarehouseList,
  updateSaveMoloniProduct,
} from "../../services/MoloniServices";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { getCommonSearchList } from "../../services/settingsServices";



const productType = [
  { value: 1, label: "Product" },
  { value: 2, label: "Service" },
  { value: 3, label: "Others" },
];

const productCategoryList = [
  { value: "M", label: "M" },
  { value: "P", label: "P" },
  { value: "A", label: "A" },
  { value: "S", label: "S" },
  { value: "T", label: "T" },
];

const AddProductMoloni = () => {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const { t } = useTranslation();
  const [btnLoader, setBtnLoader] = useState(false);
  const [productMainData, setProductMainData] = useState({
    id: "",
    moloni_id: "",
    category_id: "",
    type: "",
    name: "",
    summary: "",
    reference: "",
    price: "",
    unit_id: "",
    ean_string: "",
    has_stock: 0,
    stock: "",
    minimum_stock: "",
    pos_favorite: 0,
    at_product_category: "",
    exemption_reason: "",
    taxes: [],
    suppliers: [],
    properties: [],
    warehouse: [],
  });

  let errorsObj = {
    category_id: "",
    type: "",
    name: "",
    reference: "",
    price: "",
    unit_id: "",
    ean_string: "",
    has_stock: "",
    stock: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [categoryDataList, setCategoryDataList] = useState([]);
  const [unitDataList, setUnitDataList] = useState([]);
  const [taxDataList, setTaxDataList] = useState([]);
  const [suppliersDataList, setSuppliersDataList] = useState([]);
  const [taxErrors, setTaxErrors] = useState([]);
  const [supplierErrors, setSupplierErrors] = useState([]);
  const [propertyDataList, setPropertyDataList] = useState([]);
  const [warehouseDataList, setWarehouseDataList] = useState([]);
  const [propertyErrors, setPropertyErrors] = useState([]);
  const [warehouseErrors, setWarehouseErrors] = useState([]);
  const [productDetails, setProductDetails] = useState("");

  const [exemptionList, setExemptionList] = useState([]);
  
  
  
    useEffect(function () {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        type: "exception_list",
      };
      getCommonSearchList(data)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].code,
              label: response.data[i].description,
            });
          }
  
          setExemptionList(list);
        })
        .catch((err) => {});
    }, []);

  // const handleChange = (newValue) => {
  //   setSelectedOption(newValue);
  // };

  // const handleCreate = (inputValue) => {
  //   const newOption = { value: inputValue.toLowerCase(), label: inputValue };
  //   setCategoryDataList((prev) => [...prev, newOption]);
  //   setSelectedOption(newOption);
  // };

  // const handleChangeUnit = (newValue) => {
  //   setSelectedUnitOption(newValue);
  //   setProductMainData((prev) => ({
  //     ...prev,
  //     unit_id: newValue ? newValue.value : "",
  //   }));
  // };

  // const handleCreateUnit = (inputValue) => {
  //   const newOption = { value: inputValue.toLowerCase(), label: inputValue };
  //   setUnitDataList((prev) => [...prev, newOption]);
  //   setSelectedUnitOption(newOption);
  //   setProductMainData((prev) => ({
  //     ...prev,
  //     unit_id: newOption.value,
  //   }));
  // };

  const handleCheckboxChangePosFav = (e) => {
    setProductMainData({
      ...productMainData,
      pos_favorite: e.target.checked ? 1 : 0,
    });
  };

  const handleCheckboxChangeHasStock = (e) => {
    setProductMainData({
      ...productMainData,
      has_stock: e.target.checked ? 1 : 0,
    });
  };
  const handleAddTax = () => {
    setProductMainData((prev) => {
      const lastTax = prev.taxes[prev.taxes.length - 1];

      if (!lastTax) {
        return {
          ...prev,
          taxes: [{ tax_id: "", value: "", order: "", cumulative: 0 }],
        };
      }

      if (!lastTax.tax_id || !lastTax.value || !lastTax.order) {
        toast.error(
          "Please complete Tax,Value and Order before adding another tax",
        );
        return prev;
      }

      return {
        ...prev,
        taxes: [
          ...prev.taxes,
          { tax_id: "", value: "", order: "", cumulative: 0 },
        ],
      };
    });
  };

  const handleRemoveTax = (index) => {
    setProductMainData((prev) => ({
      ...prev,
      taxes: prev.taxes.filter((_, i) => i !== index),
    }));
  };

  const handleTaxChange = (index, field, value) => {
    setProductMainData((prev) => {
      const updatedTaxes = [...prev.taxes];
      updatedTaxes[index][field] = value;
      return { ...prev, taxes: updatedTaxes };
    });

    setTaxErrors((prevErrors) => {
      const errors = [...prevErrors];
      errors[index] = errors[index] || {};

      if (field === "tax_id" && !value) {
        errors[index].tax_id = "Tax ID is required";
      } else {
        errors[index].tax_id = "";
      }

      if (field === "value" && (value <= 0 || isNaN(value))) {
        errors[index].value = "Value must be greater than 0";
      } else {
        errors[index].value = "";
      }

      if (field === "order" && (value <= 0 || isNaN(value))) {
        errors[index].order = "Order must be greater than 0";
      } else {
        errors[index].order = "";
      }

      return errors;
    });
  };

  const handleAddSupplier = () => {
    setProductMainData((prev) => {
      const lastSupplier = prev.suppliers[prev.suppliers?.length - 1];

      if (!lastSupplier) {
        return {
          ...prev,
          suppliers: [{ supplier_id: "", cost_price: "" }],
        };
      }

      if (!lastSupplier.supplier_id || !lastSupplier.cost_price) {
        toast.error(
          "Please complete Supplier,price before adding another suppliers",
        );
        return prev;
      }

      return {
        ...prev,
        suppliers: [...prev.suppliers, { supplier_id: "", cost_price: "" }],
      };
    });
  };

  const handleRemoveSupplier = (index) => {
    setProductMainData((prev) => ({
      ...prev,
      suppliers: prev.suppliers.filter((_, i) => i !== index),
    }));
  };

  const handleChangeSupplier = (index, field, value) => {
    setProductMainData((prev) => {
      const updatedTaxes = [...prev.suppliers];
      updatedTaxes[index][field] = value;
      return { ...prev, suppliers: updatedTaxes };
    });

    setSupplierErrors((prevErrors) => {
      const errors = [...prevErrors];
      errors[index] = errors[index] || {};

      if (field === "supplier_id" && !value) {
        errors[index].supplier_id = "Supplier is required";
      } else {
        errors[index].supplier_id = "";
      }

      if (field === "cost_price" && (value <= 0 || isNaN(value))) {
        errors[index].cost_price = "Cost price is required";
      } else {
        errors[index].cost_price = "";
      }

      return errors;
    });
  };

  const handleAddProperties = () => {
    setProductMainData((prev) => {
      const lastProperties = prev.properties[prev.properties?.length - 1];

      if (!lastProperties) {
        return {
          ...prev,
          properties: [{ property_id: "", value: "" }],
        };
      }

      if (!lastProperties.property_id || !lastProperties.value) {
        toast.error(
          "Please complete property,value before adding another properties",
        );
        return prev;
      }

      return {
        ...prev,
        properties: [...prev.properties, { property_id: "", value: "" }],
      };
    });
  };

  const handleRemoveProperties = (index) => {
    setProductMainData((prev) => ({
      ...prev,
      properties: prev.properties.filter((_, i) => i !== index),
    }));
  };

  const handleChangeProperties = (index, field, value) => {
    setProductMainData((prev) => {
      const updatedProperties = [...prev.properties];
      updatedProperties[index][field] = value;
      return { ...prev, properties: updatedProperties };
    });

    setPropertyErrors((prevErrors) => {
      const errors = [...prevErrors];
      errors[index] = errors[index] || {};

      if (field === "property_id" && !value) {
        errors[index].property_id = "Property is required";
      } else {
        errors[index].property_id = "";
      }

      if (field === "value" && !value) {
        errors[index].value = "Value is required";
      } else {
        errors[index].value = "";
      }

      return errors;
    });
  };

  const handleAddWarehouse = () => {
    setProductMainData((prev) => {
      const warehouses = prev.warehouse || [];
      const lastWarehouse = warehouses[warehouses.length - 1];

      if (!lastWarehouse) {
        return {
          ...prev,
          warehouse: [{ warehouse_id: "", stock: "" }],
        };
      }

      if (!lastWarehouse.warehouse_id || !lastWarehouse.stock) {
        toast.error(
          "Please complete warehouse and stock before adding another warehouse",
        );
        return prev;
      }

      return {
        ...prev,
        warehouse: [...warehouses, { warehouse_id: "", stock: "" }],
      };
    });
  };

  const handleRemoveWarehouse = (index) => {
    setProductMainData((prev) => ({
      ...prev,
      warehouse: prev.warehouse.filter((_, i) => i !== index),
    }));
  };

  const handleChangeWarehouse = (index, field, value) => {
    setProductMainData((prev) => {
      const updatedWarehouse = [...prev.warehouse];
      updatedWarehouse[index][field] = value;
      return { ...prev, warehouse: updatedWarehouse };
    });

    setWarehouseErrors((prevErrors) => {
      const errors = [...prevErrors];
      errors[index] = errors[index] || {};

      if (field === "warehouse_id" && !value) {
        errors[index].warehouse_id = "Warhouse is required";
      } else {
        errors[index].warehouse_id = "";
      }

      if (field === "stock" && !value) {
        errors[index].stock = "Stock is required";
      } else {
        errors[index].stock = "";
      }

      return errors;
    });
  };

  useEffect(() => {
    if (uuid) {
      let data = { product_id: uuid };
      getViewMainproduct(data)
        .then((response) => {
          setProductDetails(response.data.data);
        })
        .catch((err) => {
          navigate("/products");
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [uuid]);

  useEffect(() => {
    if (productDetails) {
      setProductMainData({
        id: productDetails?.id,
        moloni_id: productDetails?.moloni_id,
        category_id: productDetails?.category_id,
        type: productDetails?.type,
        name: productDetails?.name,
        summary: productDetails?.summary,
        reference: productDetails?.reference,
        price: productDetails?.price,
        unit_id: productDetails?.unit_id,
        ean_string: productDetails?.ean,
        stock: productDetails?.stock,
        minimum_stock: productDetails?.minimum_stock,
        pos_favorite: productDetails?.pos_favorite,
        at_product_category: productDetails?.at_product_category,
        exemption_reason: productDetails?.exemption_reason,
        taxes: productDetails?.taxes,
        suppliers: productDetails?.suppliers,
        properties: productDetails?.properties,
        warehouse: productDetails?.warehouse,
        has_stock: productDetails?.has_stock,
      });
    }
  }, [productDetails]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getProductCategoryList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setCategoryDataList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getUnitList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setUnitDataList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getTaxList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setTaxDataList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListSupplierList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setSuppliersDataList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getProductPropertyList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].title,
          });
        }

        setPropertyDataList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getWarehouseList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].title,
          });
        }

        setWarehouseDataList(list);
      })
      .catch((err) => {});
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    setBtnLoader(true);

    let error = false;
    let errorObj = { ...errorsObj };
    if (!productMainData?.category_id) {
      errorObj.category_id = `Category is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!productMainData.type) {
      errorObj.type = `Type is required.`;
      error = true;
      setBtnLoader(false);
    }
    if (!productMainData.name) {
      errorObj.name = `Name is required.`;
      error = true;
      setBtnLoader(false);
    }
    if (!productMainData.reference) {
      errorObj.reference = `Reference is required.`;
      error = true;
      setBtnLoader(false);
    }
    if (!productMainData.price) {
      errorObj.price = `Price is required.`;
      error = true;
      setBtnLoader(false);
    }
    if (!productMainData.unit_id) {
      errorObj.unit_id = `Unit is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!productMainData.stock) {
      errorObj.stock = `Stock is required.`;
      error = true;
      setBtnLoader(false);
    }

    productMainData?.taxes?.forEach((tax, index) => {
      let rowError = {};

      if (!tax.tax_id) {
        rowError.tax_id = "Tax is required.";
        error = true;
      }
      if (!tax.value) {
        rowError.value = "Value is required.";
        error = true;
      }
      if (!tax.order) {
        rowError.order = "Order is required.";
        error = true;
      }

      taxErrors[index] = rowError;
    });

    productMainData?.suppliers?.forEach((items, index) => {
      let rowError = {};

      if (!items.supplier_id) {
        rowError.supplier_id = "Supplier is required.";
        error = true;
      }
      if (!items.cost_price) {
        rowError.cost_price = "Cost price is required.";
        error = true;
      }

      supplierErrors[index] = rowError;
    });

    productMainData?.properties?.forEach((item, index) => {
      let rowError = {};

      if (!item.property_id) {
        rowError.property_id = "Property is required.";
        error = true;
      }
      if (!item.value) {
        rowError.value = "Value is required.";
        error = true;
      }

      propertyErrors[index] = rowError;
    });

    productMainData?.warehouse?.forEach((item, index) => {
      let rowError = {};

      if (!item.warehouse_id) {
        rowError.warehouse_id = "Property is required.";
        error = true;
      }
      if (!item.stock) {
        rowError.stock = "Stock is required.";
        error = true;
      }

      warehouseErrors[index] = rowError;
    });

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    let data = {
      category_id: productMainData?.category_id,
      type: productMainData?.type,
      name: productMainData?.name,
      summary: productMainData?.summary,
      reference: productMainData?.reference,
      price: productMainData?.price,
      unit_id: productMainData?.unit_id,
      ean: productMainData?.ean_string,
      has_stock: productMainData?.has_stock,
      stock: productMainData?.stock,
      pos_favorite: productMainData?.pos_favorite
        ? productMainData?.pos_favorite
        : 0,
      minimum_stock: productMainData?.minimum_stock,
      at_product_category: productMainData?.at_product_category,
      exemption_reason: productMainData?.exemption_reason,
      taxes: productMainData?.taxes,
      suppliers: productMainData?.suppliers,
      properties: productMainData?.properties,
      warehouse: productMainData?.warehouse,
    };

    let updateData = {
      id: productDetails?.id,
      moloni_id: productDetails?.moloni_id,
      category_id: productMainData?.category_id,
      type: productMainData?.type,
      name: productMainData?.name,
      summary: productMainData?.summary,
      reference: productMainData?.reference,
      price: productMainData?.price,
      unit_id: productMainData?.unit_id,
      ean: productMainData?.ean_string,
      has_stock: productMainData?.has_stock,
      stock: productMainData?.stock,
      pos_favorite: productMainData?.pos_favorite
        ? productMainData?.pos_favorite
        : 0,
      minimum_stock: productMainData?.minimum_stock,
      at_product_category: productMainData?.at_product_category,
      exemption_reason: productMainData?.exemption_reason,
      taxes: productMainData?.taxes,
      suppliers: productMainData?.suppliers,
      properties: productMainData?.properties,
      warehouse: productMainData?.warehouse,
    };

    if (productDetails?.id) {
      updateSaveMoloniProduct(updateData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/products");
          setProductMainData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    } else {
      createSaveMoloniProduct(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/products");
          setProductMainData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-products")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
              </div>

              <div className="col-sm-6 text-end">
                <h1 className="page-title">{t("products")}</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="row justify-content-start">
              <div className="col-md-12">
                <div className="card card-primary">
                  <Form method={`post`} onSubmit={handleSubmit}>
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("category")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={categoryDataList}
                                  value={categoryDataList.find(
                                    (item) =>
                                      item.value == productMainData.category_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setProductMainData({
                                      ...productMainData,
                                      category_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Category"}
                                />
                                {/* <CreatableSelect
                                  isClearable
                                  options={categoryDataList}
                                  value={selectedOption}
                                  onChange={handleChange}
                                  onCreateOption={handleCreate}
                                  placeholder="Select or create category..."
                                /> */}
                              </div>
                              {errors.category_id && (
                                <span className="input-error">
                                  {errors.category_id}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("name")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={productMainData.name}
                                  onChange={(e) => {
                                    setProductMainData({
                                      ...productMainData,
                                      name: e.target.value,
                                    });
                                  }}
                                  name={`name`}
                                  maxLength={100}
                                  placeholder="Name"
                                />
                              </div>
                              {errors.name && (
                                <span className="input-error">
                                  {errors.name}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my">
                              {t("type")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={productType}
                                  value={productType.find(
                                    (item) =>
                                      item.value === productMainData.type,
                                  )}
                                  onChange={(selectedOption) => {
                                    setProductMainData({
                                      ...productMainData,
                                      type: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Type"}
                                />
                                {errors.type && (
                                  <span className="input-error">
                                    {errors.type}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("reference")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={productMainData.reference}
                                  onChange={(e) => {
                                    setProductMainData({
                                      ...productMainData,
                                      reference: e.target.value,
                                    });
                                  }}
                                  name={`reference`}
                                  maxLength={100}
                                  placeholder="Reference"
                                />
                              </div>
                              {errors.reference && (
                                <span className="input-error">
                                  {errors.reference}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("summary")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <textarea
                                  className="form-control input-search"
                                  type="text"
                                  value={productMainData.summary}
                                  onChange={(e) => {
                                    setProductMainData({
                                      ...productMainData,
                                      summary: e.target.value,
                                    });
                                  }}
                                  name={`summary`}
                                  maxLength={100}
                                  placeholder="Summary"
                                  rows={4}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("ean_string")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={productMainData.ean_string}
                                  onChange={(e) => {
                                    setProductMainData({
                                      ...productMainData,
                                      ean_string: e.target.value,
                                    });
                                  }}
                                  name={`ean_string`}
                                  maxLength={100}
                                  placeholder="Ean String"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("price")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={productMainData.price}
                                  onChange={(e) => {
                                    setProductMainData({
                                      ...productMainData,
                                      price: e.target.value,
                                    });
                                  }}
                                  name={`price`}
                                  maxLength={100}
                                  placeholder="Price"
                                />
                                {errors.price && (
                                  <span className="input-error">
                                    {errors.price}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("unit")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                {/* <CreatableSelect
                                  isClearable
                                  options={unitDataList}
                                  value={selectedUnitOption}
                                  onChange={handleChangeUnit}
                                  onCreateOption={handleCreateUnit}
                                  placeholder="Select or create unit..."
                                /> */}

                                <Select
                                  className="my-select-v"
                                  options={unitDataList}
                                  value={unitDataList.find(
                                    (item) =>
                                      item.value === productMainData.unit_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setProductMainData({
                                      ...productMainData,
                                      unit_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Unit"}
                                />
                              </div>
                              {errors.unit_id && (
                                <span className="input-error">
                                  {errors.unit_id}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("has_stock")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <div className="form-check">
                                  <input
                                    className="my-checkbox-1 form-check-input"
                                    type="checkbox"
                                    checked={productMainData.has_stock === 1}
                                    onChange={handleCheckboxChangeHasStock}
                                  />
                                  <label className="form-check-label pl-2">
                                    {t("has_stock")}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("stock")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={productMainData.stock}
                                  onChange={(e) => {
                                    setProductMainData({
                                      ...productMainData,
                                      stock: e.target.value,
                                    });
                                  }}
                                  name={`stock`}
                                  maxLength={100}
                                  placeholder="Stock"
                                />
                                {errors.stock && (
                                  <span className="input-error">
                                    {errors.stock}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("minimum_stock")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={productMainData.minimum_stock}
                                  onChange={(e) => {
                                    setProductMainData({
                                      ...productMainData,
                                      minimum_stock: e.target.value,
                                    });
                                  }}
                                  name={`minimum_stock`}
                                  maxLength={100}
                                  placeholder="Minimum Stock"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("pos_favorite")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <div className="form-check">
                                  <input
                                    className="my-checkbox-1 form-check-input"
                                    type="checkbox"
                                    checked={productMainData.pos_favorite === 1}
                                    onChange={handleCheckboxChangePosFav}
                                  />
                                  <label className="form-check-label pl-2">
                                    {t("pos_favorite")}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("at_product_category")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={productCategoryList}
                                  value={productCategoryList.find(
                                    (item) =>
                                      item.value ===
                                      productMainData.at_product_category,
                                  )}
                                  onChange={(selectedOption) => {
                                    setProductMainData({
                                      ...productMainData,
                                      at_product_category: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select At Product Category"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("exemption_reason")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={exemptionList}
                                  value={exemptionList.find(
                                    (item) =>
                                      item.value ===
                                      productMainData.exemption_reason,
                                  )}
                                  onChange={(selectedOption) => {
                                    setProductMainData({
                                      ...productMainData,
                                      exemption_reason: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Exemption Reason"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="row">
                          <div
                            className="col-md-12"
                            style={{
                              marginTop: "15px",
                              marginBottom: "15px",
                            }}
                          >
                            {" "}
                            <h5>{t("tax")}</h5>
                            <button
                              className="btn btn-primary"
                              onClick={handleAddTax}
                              type="button"
                            >
                              + {t("add")}
                            </button>
                          </div>

                          {productMainData?.taxes?.length > 0 ? (
                            <div
                              className="row justify-content-start"
                              style={{
                                maxHeight: "300px",
                                overflowY: "auto",
                              }}
                            >
                              {productMainData?.taxes?.map((tax, index) => (
                                <div className="col-md-6">
                                  <div className="fileupload-content px-4">
                                    <div
                                      className="row justify-content-start align-items-center mb-2"
                                      key={index}
                                    >
                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("tax")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <Select
                                                className="my-select-v"
                                                options={taxDataList}
                                                value={
                                                  taxDataList.find(
                                                    (item) =>
                                                      item.value === tax.tax_id,
                                                  ) || null
                                                }
                                                onChange={(selectedOption) => {
                                                  handleTaxChange(
                                                    index,
                                                    "tax_id",
                                                    selectedOption
                                                      ? selectedOption.value
                                                      : "",
                                                  );
                                                }}
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder={"Select Tax"}
                                              />
                                              {taxErrors[index]?.tax_id && (
                                                <small className="text-danger">
                                                  {taxErrors[index].tax_id}
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("value")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <input
                                                className="form-control input-search"
                                                type="number"
                                                value={tax.value}
                                                onChange={(e) =>
                                                  handleTaxChange(
                                                    index,
                                                    "value",
                                                    e.target.value,
                                                  )
                                                }
                                                placeholder="Value (%)"
                                              />
                                              {taxErrors[index]?.value && (
                                                <small className="text-danger">
                                                  {taxErrors[index].value}
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("order")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <input
                                                className="form-control input-search"
                                                type="number"
                                                value={tax.order}
                                                onChange={(e) =>
                                                  handleTaxChange(
                                                    index,
                                                    "order",
                                                    e.target.value,
                                                  )
                                                }
                                                placeholder="Order"
                                              />
                                              {taxErrors[index]?.order && (
                                                <small className="text-danger">
                                                  {taxErrors[index].order}
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="col-md-4 d-flex align-items-center">
                                        <FormGroup check>
                                          <Label check>
                                            <input
                                              type="checkbox"
                                              checked={tax.cumulative === 1}
                                              onChange={(e) =>
                                                handleTaxChange(
                                                  index,
                                                  "cumulative",
                                                  e.target.checked ? 1 : 0,
                                                )
                                              }
                                            />{" "}
                                            {t("cumulative")}
                                          </Label>
                                        </FormGroup>
                                      </div>

                                      <div className="d-flex align-items-center">
                                        <button
                                          className="btn btn-danger trash-btn-custom btn-sm ml-2"
                                          onClick={() =>
                                            handleRemoveTax(index, tax)
                                          }
                                          type="button"
                                        >
                                          <i className="bi bi-trash"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <p className="text-muted">No tax list added.</p>
                          )}
                        </div>

                        <div className="row">
                          <div
                            className="col-md-12"
                            style={{
                              marginTop: "15px",
                              marginBottom: "15px",
                            }}
                          >
                            {" "}
                            <h5>{t("suppliers")}</h5>
                            <button
                              className="btn btn-primary"
                              onClick={handleAddSupplier}
                              type="button"
                            >
                              + {t("add")}
                            </button>
                          </div>

                          {productMainData?.suppliers?.length > 0 ? (
                            <div
                              className="row justify-content-start"
                              style={{
                                maxHeight: "300px",
                                overflowY: "auto",
                              }}
                            >
                              {productMainData?.suppliers?.map((tax, index) => (
                                <div className="col-md-6">
                                  <div className="fileupload-content px-4">
                                    <div
                                      className="row justify-content-start align-items-center mb-2"
                                      key={index}
                                    >
                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("suppliers")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <Select
                                                className="my-select-v"
                                                options={suppliersDataList}
                                                value={
                                                  suppliersDataList.find(
                                                    (item) =>
                                                      item.value ===
                                                      tax.supplier_id,
                                                  ) || null
                                                }
                                                onChange={(selectedOption) => {
                                                  handleChangeSupplier(
                                                    index,
                                                    "supplier_id",
                                                    selectedOption
                                                      ? selectedOption.value
                                                      : "",
                                                  );
                                                }}
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder={"Select Suppliers"}
                                              />
                                              {supplierErrors[index]
                                                ?.supplier_id && (
                                                <small className="text-danger">
                                                  {
                                                    supplierErrors[index]
                                                      .supplier_id
                                                  }
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("cost_price")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <input
                                                className="form-control input-search"
                                                type="number"
                                                value={tax.cost_price}
                                                onChange={(e) =>
                                                  handleChangeSupplier(
                                                    index,
                                                    "cost_price",
                                                    e.target.value,
                                                  )
                                                }
                                                placeholder="Cost Price"
                                              />
                                              {supplierErrors[index]
                                                ?.cost_price && (
                                                <small className="text-danger">
                                                  {
                                                    supplierErrors[index]
                                                      .cost_price
                                                  }
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("reference")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <input
                                                className="form-control input-search"
                                                type="text"
                                                value={tax.reference}
                                                onChange={(e) =>
                                                  handleChangeSupplier(
                                                    index,
                                                    "reference",
                                                    e.target.value,
                                                  )
                                                }
                                                placeholder="Reference"
                                              />
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>
                                      <div className="d-flex align-items-center">
                                        <button
                                          className="btn btn-danger trash-btn-custom btn-sm ml-2"
                                          onClick={() =>
                                            handleRemoveSupplier(index, tax)
                                          }
                                          type="button"
                                        >
                                          <i className="bi bi-trash"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <p className="text-muted">
                              No supplier list added.
                            </p>
                          )}
                        </div>

                        <div className="row">
                          <div
                            className="col-md-12"
                            style={{
                              marginTop: "15px",
                              marginBottom: "15px",
                            }}
                          >
                            {" "}
                            <h5>{t("properties")}</h5>
                            <button
                              className="btn btn-primary"
                              onClick={handleAddProperties}
                              type="button"
                            >
                              + {t("add")}
                            </button>
                          </div>

                          {productMainData?.properties?.length > 0 ? (
                            <div
                              className="row justify-content-start"
                              style={{
                                maxHeight: "300px",
                                overflowY: "auto",
                              }}
                            >
                              {productMainData?.properties?.map(
                                (tax, index) => (
                                  <div className="col-md-6">
                                    <div className="fileupload-content px-4">
                                      <div
                                        className="row justify-content-start align-items-center mb-2"
                                        key={index}
                                      >
                                        <div className="col-md-6">
                                          <FormGroup>
                                            <Label className="col-form-label form-label">
                                              {t("properties")}
                                            </Label>
                                            <div className="col-xl-12">
                                              <div className="input-div">
                                                <Select
                                                  className="my-select-v"
                                                  options={propertyDataList}
                                                  value={
                                                    propertyDataList.find(
                                                      (item) =>
                                                        item.value ===
                                                        tax.property_id,
                                                    ) || null
                                                  }
                                                  onChange={(
                                                    selectedOption,
                                                  ) => {
                                                    handleChangeProperties(
                                                      index,
                                                      "property_id",
                                                      selectedOption
                                                        ? selectedOption.value
                                                        : "",
                                                    );
                                                  }}
                                                  isSearchable={true}
                                                  isClearable={true}
                                                  placeholder={
                                                    "Select Property"
                                                  }
                                                />
                                                {propertyErrors[index]
                                                  ?.property_id && (
                                                  <small className="text-danger">
                                                    {
                                                      propertyErrors[index]
                                                        .property_id
                                                    }
                                                  </small>
                                                )}
                                              </div>
                                            </div>
                                          </FormGroup>
                                        </div>

                                        <div className="col-md-6">
                                          <FormGroup>
                                            <Label className="col-form-label form-label">
                                              {t("value")}
                                            </Label>
                                            <div className="col-xl-12">
                                              <div className="input-div">
                                                <input
                                                  className="form-control input-search"
                                                  type="number"
                                                  value={tax.value}
                                                  onChange={(e) =>
                                                    handleChangeProperties(
                                                      index,
                                                      "value",
                                                      e.target.value,
                                                    )
                                                  }
                                                  placeholder="Value"
                                                />
                                                {propertyErrors[index]
                                                  ?.value && (
                                                  <small className="text-danger">
                                                    {
                                                      propertyErrors[index]
                                                        .value
                                                    }
                                                  </small>
                                                )}
                                              </div>
                                            </div>
                                          </FormGroup>
                                        </div>

                                        <div className="d-flex align-items-center">
                                          <button
                                            className="btn btn-danger trash-btn-custom btn-sm ml-2"
                                            onClick={() =>
                                              handleRemoveProperties(index, tax)
                                            }
                                            type="button"
                                          >
                                            <i className="bi bi-trash"></i>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )}
                            </div>
                          ) : (
                            <p className="text-muted">
                              No property list added.
                            </p>
                          )}
                        </div>

                        <div className="row">
                          <div
                            className="col-md-12"
                            style={{
                              marginTop: "15px",
                              marginBottom: "15px",
                            }}
                          >
                            {" "}
                            <h5>{t("warehouse")}</h5>
                            <button
                              className="btn btn-primary"
                              onClick={handleAddWarehouse}
                              type="button"
                            >
                              + {t("add")}
                            </button>
                          </div>

                          {productMainData?.warehouse?.length > 0 ? (
                            <div
                              className="row justify-content-start"
                              style={{
                                maxHeight: "300px",
                                overflowY: "auto",
                              }}
                            >
                              {productMainData?.warehouse?.map((tax, index) => (
                                <div className="col-md-6">
                                  <div className="fileupload-content px-4">
                                    <div
                                      className="row justify-content-start align-items-center mb-2"
                                      key={index}
                                    >
                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("warehouse")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <Select
                                                className="my-select-v"
                                                options={warehouseDataList}
                                                value={
                                                  warehouseDataList.find(
                                                    (item) =>
                                                      item.value ===
                                                      tax.warehouse_id,
                                                  ) || null
                                                }
                                                onChange={(selectedOption) => {
                                                  handleChangeWarehouse(
                                                    index,
                                                    "warehouse_id",
                                                    selectedOption
                                                      ? selectedOption.value
                                                      : "",
                                                  );
                                                }}
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder={"Select Warehouse"}
                                              />
                                              {warehouseErrors[index]
                                                ?.warehouse_id && (
                                                <small className="text-danger">
                                                  {
                                                    warehouseErrors[index]
                                                      .warehouse_id
                                                  }
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("stock")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <input
                                                className="form-control input-search"
                                                type="number"
                                                value={tax.stock}
                                                onChange={(e) =>
                                                  handleChangeWarehouse(
                                                    index,
                                                    "stock",
                                                    e.target.value,
                                                  )
                                                }
                                                name="stock"
                                                placeholder="Stock"
                                              />
                                              {warehouseErrors[index]
                                                ?.stock && (
                                                <small className="text-danger">
                                                  {warehouseErrors[index].stock}
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="d-flex align-items-center">
                                        <button
                                          className="btn btn-danger trash-btn-custom btn-sm ml-2"
                                          onClick={() =>
                                            handleRemoveWarehouse(index, tax)
                                          }
                                          type="button"
                                        >
                                          <i className="bi bi-trash"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <p className="text-muted">
                              No property list added.
                            </p>
                          )}
                        </div>

                        <div className="row">
                          <div className="col ms-2">
                            <button
                              type="button"
                              className="back-btn"
                              onClick={() => navigate("/products")}
                            >
                              <i className="bi bi-arrow-left"> </i> {t("back")}
                            </button>
                          </div>
                          <div className="col">
                            <div className="d-flex justify-content-end nxt-btn">
                              {btnLoader === true ? (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  Loading...
                                </button>
                              ) : (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  {t("submit")} <i className="bi bi-check2"></i>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AddProductMoloni;
